import axios from '@/axios'
import Vue from 'vue'

const state = {
  rewards: [],
  categories: [],
};

const actions = {
  fetchEntityRewards({commit, rootState}, config) {
    return axios.get('/entity/rewards', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_ENTITY_REWARDS', r.data.rewards)
          commit('SAVE_ENTITY_CATEGORIES', rootState.settings.rewardsCategoriesAsGrid
            ? r.data.categories
            : [{id: 0, name: 'Wszystkie kategorie'}].concat(r.data.categories))
        } else {
          throw new Error("Entity rewards forbidden");
        }
      })
  },
  fetchEntityByCategoryHidRewards({commit, rootState}, config) {
    return axios.get('/entity/rewards/' + config.route.params.id, config)
        .then((r) => {
          if (r.data.success) {
            commit('SAVE_ENTITY_REWARDS', r.data.rewards);
            commit('SAVE_ENTITY_CATEGORIES', [r.data.category]);
          } else {
            throw new Error("Entity rewards forbidden");
          }
        })
  }
};

const mutations = {
  SAVE_ENTITY_REWARDS(state, messages) {
    Vue.set(state, 'rewards', messages);
  },
  SAVE_ENTITY_CATEGORIES(state, messages) {
    Vue.set(state, 'categories', messages);
  },
};

export default {
  state,
  actions,
  mutations,
}
